import React from "react";
import { ActiveWerkbonBanner } from "../WerkbonViewShared";

export default function WerkbonHeader({ activeTodayWerkbon }) {
  return (
    <div className="mb-4 rounded-xl border border-slate-200 bg-white px-4 py-3">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <h1 className="text-xl font-bold text-slate-900">Mijn werkbonnen</h1>
          <p className="text-sm text-slate-600">
            Open de juiste bon en werk vanuit één compacte uitvoeringsweergave.
          </p>
        </div>
        <div className="lg:max-w-md lg:flex-1">
          <ActiveWerkbonBanner werkbon={activeTodayWerkbon} />
        </div>
      </div>
      <div className="mt-3 border-t border-slate-100 pt-3 text-xs text-slate-500">
        Planning links, uitvoering rechts. Minder panelen, meer focus op wat nu moet gebeuren.
      </div>
    </div>
  );
}
